import styled from "styled-components/macro";

export const Error = styled.div`
  color: ${({ theme, color }) => color || theme.colors.inputError};
  font-size: 0.8rem;
  font-weight: 500;
`;
